module.exports = __webpack_public_path__ + "img/cogs.9c1585ea.svg";